var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleicon = function SvgCheckCircleicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm0 12.6A5.6 5.6 0 1 1 7 1.4a5.6 5.6 0 0 1 0 11.2Zm2.184-8.057a.35.35 0 0 1 .49 0l.35.371a.35.35 0 0 1 0 .497L6.09 9.345a.336.336 0 0 1-.49 0L3.955 7.686a.35.35 0 0 1 0-.497l.371-.371a.336.336 0 0 1 .49 0l1.05 1.043 3.318-3.318Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircleicon;